export namespace PaymentAccountErrorConstants {
  export const CREDIT_CARD_EXPIRATION_IS_PAST: RegExp = /The Credit Card expiration date is in the past/;
  export const LAST_PAYMENT_ACCOUNT_CANNOT_BE_DELETED: RegExp =
    /The last payment account for a rider cannot be deleted when they have rides scheduled/;
  export const COULD_NOT_CREATE_PAYMENT_ACCOUNT: RegExp = /Could not verify ACH payment account/;
  export const TRANSACTION_DECLINED: RegExp = /This transaction has been declined/;
  export const DUPLICATE_TRANSACTION: RegExp = /A duplicate transaction has been submitted/;
  export const PAYMENT_ACCOUNT_ALREADY_ON_FILE: RegExp = /PaymentAccount already on file/;
  export const CREDIT_CARD_CANNOT_DELETE_DEFAULT: RegExp = /default and cannot be deleted/;
}
